import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function NewSwitch({ tabsData, currentTab, onChangeTab }) {
  const boxStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    borderRadius: "7px",
    height: "48px",
    padding: "0px 18px ",
    cursor: "pointer",
    width: "19%",
  };

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      p="8px"
      border="2px solid #05346299"
      borderRadius="8px"
    >
      {tabsData.map((tabItem) => (
        <Box
          key={tabItem.id}
          sx={boxStyle}
          bgcolor={currentTab === tabItem.id ? "#053462" : ""}
          onClick={() => onChangeTab(tabItem)}
        >
          <Typography
            fontSize="13px"
            fontWeight={currentTab === tabItem.id ? 700 : 600}
            color={currentTab === tabItem.id ? "#fff" : "#053462"}
          >
            {tabItem.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
